import { Inject, Injectable, inject } from '@angular/core';
import { DialogService, ProjectService } from '@wms/app/services';
import { VcsAPIService } from '../services/vcs-api/vcs-api.service';
import { BaseComponent } from '../../components/base/base.component';
import { formatCommitMsg, hideMsg, isEmailType, showMsg } from '../utils/vcs-utils';
import { NotificationService } from '@wms/services';
import {getValidJSON, replace} from '@wm/core';
import { IPushChanges } from '../interface/push-changes';
import { IVcsFileStatusMap } from '../interface/vcs-file-status-map';
import { IFileItem } from '../interface/file-item';
import { IchildFile } from '../interface/child-file';
import { ICommit } from '../interface/commit';
import { IVCSConfig } from '../interface/vcs-config';
import { IFileDiffResponse } from '../interface/file-diff-response';
import { IVcsProvider } from '../interface/vcs-provider';
import { inRange } from 'lodash-es';
@Injectable({
  providedIn: 'root',
})
export class VcsService extends BaseComponent {
  private dialogService: DialogService;
  private vcsAPIService: VcsAPIService;
  private notificationService: NotificationService;
  public changesType:string
  public commitHistoryChanges:any;
  public selectedTab: string;

  public pushChangesInfo: IPushChanges = {
    commitMsg: '',
    defaultCommitMsg: '',
    migrationCommitMsg:'',
    migrationCommitDis:''

  };
  public msgData = { type: '', show: false, caption: '' };
  public fileList: any;
  public commitsList: ICommit[];
  public offset = 0;
  public isDisableNext: boolean = true;
  public isDisablePrevious: boolean = true;
  public isDisablePushBtn: boolean = false;
  public fileDiffResponse: IFileDiffResponse;
  public diffFileDetails: IchildFile
  public diffEditor: any
  public isViewingDiffFromCommitHistory: boolean = false
  public selectedProvider = {
    text: '',
    value: '',
    icon: '',
    placeholder: '',
    provider_hint: '',
    active: true,
  };
  baseURL = 'assets'
  public vcsProviders: IVcsProvider[]
  public vcsConfig: IVCSConfig = {
    type: 'GIT_HUB',
    url: '',
    username: '',
    password: '',
  };

  public projectDetails: any;
  public isExportDisabled: boolean = true;
  public vcsBranchesList: string[] = [];
  public vcsBranchName: string = 'master'
  public EXTERNAL_REPO_DETAILS_KEY = 'wms:external_repo_details'
  private diffClassNames = {
    borderTop: 'diff-border-top',
    borderBottom: 'diff-border-bottom'
  }

  public isTwoWayModalOpened: boolean = false
  public vcspullreq: boolean = false
  public hasVCSChanges: boolean = false
  appBaseMetaInfo: any;
  public externalRepoEnable:boolean = false
  public vcsAction:string;
  public isActionDisabled:boolean;

  dialogParams: any;
  pushActionCB : Function;
  vcsCommitMsg: any
  exportProjectasShellDialog:boolean = false;
  publishProjectAsCore:boolean = false
  reloadProject: boolean = false
  behindCommitsMessage = '';
  gitStatus: {
    devBranchTrackingStatus: {
      developmentBranch: string,
      developerBranchCommitInfo: ICommit
    },
    repoRemoteTrackingStatus: {
      remoteTrackingBranchName: string,
      behindCount: number
    }
  };

  constructor(@Inject("APP_BUILD_META_INFO") appBaseMetaInfo: any) {
    super();
    this.appBaseMetaInfo = appBaseMetaInfo;
    this.baseURL = this.appBaseMetaInfo.CDN_BASE_URL ? this.appBaseMetaInfo.CDN_BASE_URL + this.baseURL : this.baseURL;
    this.vcsAPIService = inject(VcsAPIService);
    this.dialogService = inject(DialogService);
    this.projectDetails = this.projectService.getDetails();
    this.notificationService = inject(NotificationService);
    this.vcsProviders = [
      {
        text: 'GITHUB',
        value: 'GIT_HUB',
        icon: `${this.baseURL}/images/vcs-provider/Github.png`,
        placeholder: 'https://github.com/userName/ProjectName.git',
        provider_hint: this.locale.MESSAGE_REPO_DETAILS_HINT.replace('${0}', [
          'GitHub',
        ]),
        active: true,
      },
      {
        text: 'BITBUCKET',
        value: 'BITBUCKET',
        icon: `${this.baseURL}/images/vcs-provider/Bitbucket.png`,
        placeholder: 'https://userName@bitbucket.org/userName/ProjectName.git',
        provider_hint: this.locale.MESSAGE_REPO_DETAILS_HINT.replace('${0}', [
          'BitBucket',
        ]),
        active: false,
      },
      {
        text: 'GITREPO',
        value: 'CUSTOM_GIT',
        icon: `${this.baseURL}/images/vcs-provider/Gitrepo.png`,
        placeholder: 'https://gitserver.com/userName/ProjectName.git',
        provider_hint: this.locale.MESSAGE_REPO_DETAILS_HINT.replace('${0}', [
          'any Git',
        ]),
        active: false,
      },
    ];

  }

  closeDialogWithId(id: string): void {
    if((this.exportProjectasShellDialog || this.publishProjectAsCore) && id === "pushChangesModal"){
      this.exportProjectasShellDialog = this.publishProjectAsCore = false;
    }
    this.dialogService.close(id);
  }
  openDialogWithId(id: string): void {
    this.msgData = hideMsg()
    this.dialogService.open(id);
  }

  getCommitsLog(): void {
    this.vcsAPIService.loadCommitLogs(this.offset).then((response): void => {
      if (response.length === 11) {
        this.isDisableNext = false;
        this.isDisablePrevious = this.offset === 0 ? true : false;
        response.pop();
      } else {
        this.isDisableNext = true;
      }
      this.commitsList = response;
    });
  }

  getGitStatus() {
     this.vcsAPIService.gitStatus().then(response => {
       this.gitStatus = response;
       this.behindCommitsMessage = '';
       if(this.gitStatus.repoRemoteTrackingStatus.behindCount) {
         this.behindCommitsMessage = replace(this.locale.MSG_BRANCH_BEHIND_REMOTE_BRANCH, [this.gitStatus.repoRemoteTrackingStatus.remoteTrackingBranchName, this.gitStatus.repoRemoteTrackingStatus.behindCount]) || '';
       }
    });
  }

  selectVCSProvider(provider?: any, isOnclickEvent?: boolean) {
    if (!provider) {
      provider = this.vcsProviders[0];
    }
    this.vcsProviders.forEach(function (obj) {
      obj.active = false;
    });
    this.vcsConfig = {
      type: '',
      url: '',
      username: '',
      password: '',
    }
    provider.active = true;
    this.msgData = hideMsg();
    this.selectedProvider = provider;
    this.vcsProviders.map((provider) => {
      if (provider.value === this.selectedProvider.value) {
        this.selectedProvider['active'] = true;
        provider['active'] = true;
      } else {
        provider['active'] = false;
      }
    });
    this.vcsBranchesList = []
    this.vcsBranchName = 'master'
    if (!isOnclickEvent || (isOnclickEvent && this.vcsConfig.type !== provider.value)) {
      this.vcsConfig['type'] = provider.value;
      let vcsConfigDetails = this.getExternalRepoDetailsFromCache()
      this.projectDetails = this.projectService.getDetails()
      vcsConfigDetails = vcsConfigDetails?.[this.projectDetails?.id]?.[this.vcsConfig.type];
      if (vcsConfigDetails) {
        this.vcsConfig.username = vcsConfigDetails.username;
        this.vcsConfig.url = vcsConfigDetails.url;
      }
    }
  }

  checkIsPublicRepo() {
    if (this.vcsConfig.url) {
      let repoName: string | undefined = this.vcsConfig.url.split('/').pop();
      let isRepoNameSame: boolean;
      repoName = repoName?.replace('.git', '');
      isRepoNameSame = this.projectDetails.name === repoName ? true : false;
      this.msgData = isRepoNameSame ? hideMsg() : showMsg(this.locale.MESSAGE_WARN_VCS_REPO_URL_DIFFERENT.replace(/\$\{0\}/g, this.projectDetails.name).replace(/\$\{1\}/g, repoName), 'warn');
    }

  }
  validateVCSConfigAndGetVCSBranches() {
    this.isExportDisabled = this.vcsConfig.username && this.vcsConfig.password && this.vcsConfig.url ? false : true;
    if (!this.isExportDisabled) {
      this.getVcsBranches();
    }
  }
  getVcsBranches() {
    this.vcsBranchesList = [];
    if (this.validateVCSConfig(true)) {
      this.vcsAPIService.getVcsBranches(this.vcsConfig).then((response): void => {
        if (response.length > 0) {
          this.vcsBranchesList = response
        } else {
          this.vcsBranchesList.push(this.vcsBranchName)
        }
      }).catch((error) => {
        this.isExportDisabled = true
        this.msgData = showMsg(error.error.errors.error[0].message.replace('{0}', error.error.errors.error[0].parameters[0]), 'error')
      });
    }
  }

  validateVCSConfig(isAdd: boolean) {
    let isValid = false;
    this.msgData = hideMsg();
    if (isAdd) {
      if (!this.vcsConfig.url) {
        this.msgData = showMsg(this.locale.MESSAGE_WARN_VCS_URL_EMPTY, 'error');
        this.isExportDisabled = true;
      } else if (!this.vcsConfig.username) {
        this.msgData = showMsg(this.locale.MESSAGE_WARN_VCS_USERNAME_EMPTY, 'error');
        this.isExportDisabled = true;
      } else if (isEmailType(this.vcsConfig.username)) {
        this.msgData = showMsg(this.locale.MESSAGE_WARN_VCS_USERNAME_INVALID, 'error');
        this.isExportDisabled = true;
      } else if (!this.vcsConfig.password) {
        this.msgData = showMsg(this.locale.MESSAGE_WARN_PASSWORD_EMPTY, 'error');
        this.isExportDisabled = true;
      } else {
        isValid = true;
        this.isExportDisabled = false;
      }
    }
    return isValid;
  }

  onBranchSelect($event: any) {
    this.vcsBranchName = $event.value || $event;
  }

  onBranchUnSelect() {
    this.vcsBranchName = '';
  }

  openPushProjectDialog(callback ?: Function) {
    this.msgData = showMsg(this.locale['MESSAGE_VCS_PUSHING'], 'loading');
    this.isDisablePushBtn = false;
    this.pushChangesInfo = { commitMsg: '', defaultCommitMsg: '',migrationCommitMsg: '' , migrationCommitDis: ''};

    if(callback)
      this.pushActionCB = callback;

    this.vcsAPIService.getChangesDetails().then((response): void => {
      if(!!response.unPushedChanges) {
        this.pushChangesInfo.defaultCommitMsg = response.changesTypeVsDescription.USER_CHANGES_SINCE_LAST_PULLED;
        this.pushChangesInfo.commitMsg = response.userCommitMessagePrefix || '';
        this.pushChangesInfo.migrationCommitDis = response.changesTypeVsDescription.MIGRATION_CHANGES_ON_LAST_PULLED || '';
        this.pushChangesInfo.migrationCommitMsg = response.migrationCommitMessagePrefix|| '';
        this.externalRepoEnable = this.vcsAction === 'pushtoExternalRepo' ? true : false
        this.openDialogWithId('pushChangesModal');
        if (this.exportProjectasShellDialog || this.publishProjectAsCore) {
          this.msgData = showMsg(this.locale.MESSAGE_VCS_PUBLISH, 'info');
        } else {
          this.msgData = hideMsg();
        }
      } else {
        callback ? this.checkRepoStatus() : this.notificationService.show('info', '', this.locale['MESSAGE_NO_FILES_PUSH']);
      }
    });
  }

  checkRepoStatus(callback?: Function): void {
    if(callback)
      this.pushActionCB = callback;
    this.vcsAPIService.repoStatus().then((statusObj: any) => {
      if (statusObj && statusObj !== 'false' && this.pushActionCB) {
        //if the response is true then the vcs repo is already updated, just invoke the callback
        this.pushActionCB();
      } else {
        this.openDialogWithId('pullChangesModal')
      }
    }, (error: any) => {
      this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, error);
    });
  }

  showUserVCSCredentialsDialog(params: any, errorMessage: string) {
    this.projectService.getProjAssociatedVCSInfo(this.projectService.projectEdnDetails.vcsAccountId).then((vcsInfo: any) => {
        if (vcsInfo.developerKeysEnabled) {
          this.dialogParams = {
            'vcsInfo'     : vcsInfo,
            'vcsAccountId': this.projectService.projectEdnDetails.vcsAccountId,
            'githubAppsAuth': !!(
              this.projectService.projectEdnDetails.vcsAccountDTO.properties &&
              this.projectService.projectEdnDetails.vcsAccountDTO.properties.GITHUB_AUTH_MODE === 'GITHUB_APPS'
            ),
          };
          this.openDialogWithId('vcsUserCredentials');
        } else
          this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, errorMessage);
      }, () => {
      this.notificationService.show('error', this.locale.MESSAGE_ERROR_TITLE, errorMessage);
    })

  }
  openPushDialog() {
    this.closeDialogWithId('pushExternalRepoChangesModal')
    this.openPushProjectDialog()
  }

  getExternalRepoDetailsFromCache() {
    return getValidJSON(localStorage.getItem(this.EXTERNAL_REPO_DETAILS_KEY)) || {}
  }

  goToPrevDiff() {
    const diffPositions = this.getDiffPositions()
    this.removeClass(diffPositions)
    this.diffEditor.edit.execCommand('goPrevDiff');
    const prevDiff = diffPositions.find((diff: any) => inRange(this.diffEditor.editor().getCursor().line, diff.start, diff.end))
    prevDiff && this.addClass(prevDiff.start, prevDiff.end)
  }

  goToNextDiff() {
    const diffPositions = this.getDiffPositions()
    this.removeClass(diffPositions)
    this.diffEditor.editor().execCommand('goNextDiff');
    const nextDiff = diffPositions.find((diff: any) => inRange(this.diffEditor.editor().getCursor().line, diff.start, diff.end))
    nextDiff && this.addClass(nextDiff.start, nextDiff.end)
  }

  private addClass(lineStart: number, lineEnd: number) {
    this.diffEditor
      .editor()
      .addLineClass(
        lineStart,
        'background',
        this.diffClassNames.borderTop
      );

    this.diffEditor
      .editor()
      .addLineClass(
        lineEnd - 1,
        'background',
        this.diffClassNames.borderBottom
      );

  }

  private removeClass(diffPositions: any[]) {
    diffPositions.forEach(({ start, end }) => {
      this.diffEditor.editor().eachLine(start, end, (line: { lineNo: () => any; }) => {
        for (const [_, className] of Object.entries(this.diffClassNames)) {
          this.diffEditor
            .editor()
            .removeLineClass(
              line.lineNo(),
              'background',
              className
            );
        }
      })
    })
  }

  private getDiffPositions() {
    const leftDiff = this.diffEditor
      .leftChunks()?.map((diff: any) => ({ start: diff.editFrom, end: diff.editTo }))
    const rightDiff = this.diffEditor
      .rightChunks()?.map((diff: any) => ({ start: diff.editFrom, end: diff.editTo }))

    return (leftDiff && rightDiff) ? this.mergeDiffPositions([...leftDiff, ...rightDiff]) : leftDiff ?? rightDiff
  }

  private mergeDiffPositions(diffArray: any[]) {
    diffArray.sort((a, b) => a.start - b.start)
    const result = []
    let pair = diffArray[0]

    for (const i of diffArray) {
      if (pair.end >= i.start) {
        pair.end = Math.max(i.end, pair.end)
      } else {
        result.push(pair)
        pair = i
      }
    }
    result.push(pair)
    return result
  }

  setVCSCommitMsg(prfabCommit?:boolean) {
    const vcsFileStatusArrayMap: IVcsFileStatusMap = {ADDED: [], MODIFIED: [], DELETED: []};
    let commitMsg = this.locale.MESSAGE_VCS_NO_CHANGES;
    this.vcsCommitMsg = '';
    return this.vcsAPIService.loadChanges().then((response): void => {
      this.fileList = response;
      this.fileList?.changesTypeVsDiffEntriesMap.OVERALL_CHANGES_SINCE_LAST_PULLED.forEach( (file:any)=> {
        const {filepath, vcsDiffType} = file;
        vcsFileStatusArrayMap[vcsDiffType].push(filepath.replace(/^.*[\\\/]/, ''));
      });
      const addedFileNameArray = vcsFileStatusArrayMap['ADDED'];
      const modifiedFileNameArray = vcsFileStatusArrayMap['MODIFIED'];
      const deletedFileNameArray = vcsFileStatusArrayMap['DELETED'];
      if(prfabCommit){
        commitMsg = replace(this.locale.MESSAGE_VCS_COMMIT_TEMPLATE, [addedFileNameArray,modifiedFileNameArray,'', '',deletedFileNameArray]) || ''
        this.vcsCommitMsg = commitMsg
      }else{
        if ( this.fileList?.changesTypeVsDiffEntriesMap && this.hasAnyChanges(this.fileList?.changesTypeVsDiffEntriesMap)) {
          const noOfFiles = addedFileNameArray.length + modifiedFileNameArray.length + deletedFileNameArray.length;
          if (noOfFiles) {
            commitMsg = replace(this.locale.MESSAGE_VCS_COMMIT_TEMPLATE, [addedFileNameArray.toString(), modifiedFileNameArray.toString(), '', '', deletedFileNameArray.toString()]) || '';
          }
          this.vcsCommitMsg = commitMsg;
        }
      }
    });
  }
  openViewChangesDialogue(changes:any) {
    this.fileList = changes;
    if (this.fileList?.changesTypeVsDiffEntriesMap && this.hasAnyChanges(this.fileList?.changesTypeVsDiffEntriesMap)) {
      this.selectedTab = 'My Changes';
      this.openDialogWithId("viewChangesModal")
    } else {
      this.notificationService.show('info', '', this.locale['MESSAGE_NO_FILES_VIEW']);
    }
  }

  hasAnyChanges(map: { [key: string]: any[] }): boolean {
    return Object.values(map).some((entries) => entries.length > 0);
  }



}
